import { Paragraph, Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'

export default function MaxGroupJoinErrorOverlay({ overlay, maxGroupsPerUser }) {
  const [t] = useTranslation()
  return (
    <DialogOverlay {...overlay} title={t('group-management.group-limit-reached.heading')}>
      <Paragraph>{t('group-management.max-groups-reached.error', { maxGroups: maxGroupsPerUser })}</Paragraph>

      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button data-testid="join-group-overlay.decline.button" emphasis="high" onClick={overlay.close}>
            {t('common-ui:ok.action')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
